/**
 * config.ts — Configuration centralisée de l'application.
 *
 * Point d'entrée UNIQUE pour toutes les constantes d'environnement.
 *
 * Usage :
 *   import { BACKEND } from '../utils/config'
 *
 * @version 1.0.0
 */

/// <reference types="vite/client" />

/** URL du backend (Railway / local) */
export const BACKEND: string =
  import.meta.env.VITE_BACKEND_URL || 'http://localhost:3001'

/** URL de l'API (BACKEND + /api) */
export const API_BASE: string = `${BACKEND}/api`
